<template>
  <div class="contracts type-center mtb20 flex al-cn">
    <div class="ml40 pl20">
      <div class="title">全城海量真房源，价格透明，服务专业</div>
      <div class="search mt10 flex ju-sp">
        <div>
          <el-form ref="form" :model="form" label-width="140px" :rules="rules">
            <el-form-item label-width="0px" prop="mobile">
              <el-input
                  class="input1"
                  style="width: 365px;height: 100%;padding: 5px"
                  placeholder="请输入手机号"
                  v-model="form.mobile">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="but" @click="searchClick">立即委托</div>
      </div>
    </div>
    <!--    提交成功提示-->
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <div class="Tips">
        <div class="flex ju-cn mb20">
          <img class="Submit-successfully" src="../assets/icon/Submit-successfully.png"/>
        </div>
        <div class="align-center successTip">已经成功提交需求，1-3个工作日内客户经理将联系您。</div>
      </div>
      <div slot="footer" class="dialog-footer pt10 border">
        <el-button type="success" @click="Back">返回首页</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Api from "@/api/api";

export default {
  data() {
    return {
      phone: '',
      form: {
        mobile: '',
      },
      centerDialogVisible: false,
      rules: {
        mobile: [
          {required: true, message: '手机号不能为空', trigger: 'blur'},
          {pattern: /^1[345789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    searchClick() {
      this.$emit('searchClick', this.form.mobile)
      //表单验证
      this.$refs['form'].validate((valid) => {
        if (valid) {
          Api.contracts({form: this.form})
              .then((result) => {
                // 通知父端组件提交完成了
                this.centerDialogVisible = true
              })
        } else {
          return false;
        }
      });
    },
    //返回首页
    Back() {

      if (this.$router.currentRoute.name == "entrust")
        this.$router.push({name: 'Home'});
      else
        window.location.reload();
    }
  }
}
</script>

<style scoped lang="scss">
.contracts {
  background: url(../assets/slices/bianzu.png) no-repeat;
  background-size: cover;
  width: 1359px;
  height: 278px;

  .title {
    font-size: 26px;
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 500;
    color: #000000;
  }
}

.search {
  width: 480px;
  height: 49px;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #6DB84F;

  .but {
    width: 104px;
    height: 49px;
    background: #6EBB53;
    cursor: default;
    border-radius: 8px;
    font-size: 16px;
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 49px;
    text-align: center;
  }
}
</style>
